import { BuyButtonMajor } from "@shopify/polaris-icons";
import { IMenuItems, MenuItemType } from "./MenuModel";
const buttonWidget: IMenuItems = {
  id: "button-widget",
  title: "Button Widget",
  type: MenuItemType.Item,
  url: "/button-widget",
  icon: BuyButtonMajor,
  featureHighlight: true
};

export default buttonWidget;
